import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Loader from '../elements/Loader';

const ApprovalConfirmationModal = ({ isOpen, onClose, onConfirm, action, isLoading }) => {
  const isApprove = action === 'approve';
  
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isApprove ? "Approve User" : "Reject User"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {isApprove 
            ? "Are you sure you want to approve this user?" 
            : "Are you sure you want to reject this user?"}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button 
          variant={isApprove ? "success" : "danger"}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="d-flex align-items-center">
              {isApprove ? "Approving" : "Rejecting"} 
              <Loader isInline color="text-white" />
            </span>
          ) : (isApprove ? "Approve" : "Reject")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApprovalConfirmationModal;
